import toTitleCase from '@hooks/toTitleCase';
import { DefaultRootState } from '@reduxLocal/persistState';
import noticeDispatcher from '@utils/noticeDispatcher';
import { useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useMessageList } from '../Context/MessageListContext';
import { useQueryClient } from '@tanstack/react-query';

export const useSocketHandlers = ({
	contextDispatch,
	selectedConversation,
	setMessageArray,
	playSound,
	clearBadge,
	messageModalDisplayed,
}) => {
	// Assuming the user object type is { _id: string; profile_information: { name: string; surname: string; avatar: { img: string } } }
	const messagesOpen = useSelector(
		(state: DefaultRootState) => state.UI.messagesOpen
	);

	const queryClient = useQueryClient();

	const statusUpdateHandler = (event) => {
		contextDispatch({
			type: 'UPDATE_STATUS',
			userId: event,
			status: 'available',
		});
	};

	const responseHandler = async (event) => {
		try {
			console.log('📥 socket response event', {
				convoId: event?.convoId,
				conversationId: event?.conversationId,
				userId: event?.user?._id,
				modalOpen: messageModalDisplayed,
				selectedConversationId: selectedConversation?.conversationId,
			});
			if (event.user._id) {
				console.log('➕ increment badge for', event.user._id);
				contextDispatch({
					type: 'UPDATE_BADGE',
					userId: event.user._id,
					amount: 1,
					event,
				});
				queryClient.invalidateQueries({
					queryKey: [
						'messageArray',
						event.convoId || event.conversationId || event.user._id,
					],
				});
			}
			if (
				messageModalDisplayed &&
				selectedConversation?.id &&
				(event.convoId === selectedConversation?.conversationId ||
					event.conversationId ===
						selectedConversation?.conversationId)
			) {
				console.log(
					'♻️ clearing badge for open conversation',
					selectedConversation?.id
				);
				contextDispatch({
					type: 'UPDATE_BADGE',
					userId: selectedConversation.id,
					amount: -999,
					event: {
						...event,
						convoId: event.convoId || event.conversationId,
					},
				});
				clearBadge?.(selectedConversation.id);
				queryClient.invalidateQueries({
					queryKey: [
						'messageArray',
						selectedConversation.conversationId ||
							selectedConversation.id,
					],
				});
			}
			if (!messagesOpen && event.user.profile_information) {
				console.log('🔔 dispatching notification');
				noticeDispatcher({
					title:
						'💬 ' +
						toTitleCase(event.user.profile_information.name) +
						' ' +
						toTitleCase(event.user.profile_information.surname),
					body: event.text,
					image: event.user.profile_information.avatar.img || '',
					timestamp: event.timestamp,
					type: 'message',
				});
			}
		} catch (e) {
			console.error('Error updating convo or message', e);
		}
	};

	const acknowledgeHandler = useCallback(
		(event) => {
			console.log('acknowledged');
		},
		[selectedConversation]
	);

	const deliveredHandler = useCallback(({ event }) => {
		console.log('delivered');
	}, []);

	const handleStatusUpdate = ({ event, status }) => {
		setMessageArray((prev) =>
			prev.map((item) =>
				item._id === event.id
					? {
							...item,
							pending: false,
							sent: true,
							...(status ? { [status]: true } : {}),
						}
					: item
			)
		);
	};

	return {
		responseHandler,
		acknowledgeHandler,
		deliveredHandler,
		handleStatusUpdate,
		statusUpdateHandler,
	};
};
